<template>
  <div class="container-fluid p-3">
    <h3 class="mb-3">Data Warga</h3>

    <div class="table-responsive">
      <table id="wargaTable" class="display nowrap" style="width:100%"></table>
    </div>

    <!-- Modal Kendaraan -->
    <div
      class="modal fade"
      id="kendaraanModal"
      tabindex="-1"
      aria-hidden="true"
      ref="kendaraanModalRef"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              Daftar Kendaraan {{ selectedWarga?.nama_lengkap }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <div v-if="kendaraanLoading" class="text-muted">
              Memuat data kendaraan...
            </div>
            <table v-else class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Jenis Kendaraan</th>
                  <th>Plat Nomor</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(k, i) in kendaraan" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td>{{ k.type_kendaraan }}</td>
                  <td>{{ k.plat_nomor }}</td>
                </tr>
                <tr v-if="kendaraan.length === 0">
                  <td colspan="3" class="text-center text-muted">Tidak ada kendaraan</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import $ from "jquery"
import "datatables.net-dt"
import "datatables.net-dt/css/dataTables.dataTables.css"
import axios from "axios"
import * as bootstrap from "bootstrap"
import qs from "qs"

const token = localStorage.getItem("token")
const userLogin = localStorage.getItem("username") || ""

const kendaraan = ref([])
const kendaraanLoading = ref(false)
const selectedWarga = ref(null)
const kendaraanModalRef = ref(null)
let kendaraanModalInstance = null

onMounted(() => {
  if (!userLogin || !token) {
    alert("Session login tidak ditemukan, silakan login ulang.")
    return
  }

  kendaraanModalInstance = new bootstrap.Modal(kendaraanModalRef.value)

  // Init DataTable
  const table = $("#wargaTable").DataTable({
    processing: true,
    serverSide: false,
    destroy: true,
    scrollX: true,
    ajax: {
      url: "https://metatekapps.metateknologi.com/api-vms-data-warga.php",
      type: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        token: token,
        user_login: userLogin,
      },
      dataSrc: function (json) {
        return json.data || []
      },
    },
    columns: [
      { data: "email", title: "Email" },
      { data: "nama_lengkap", title: "Nama Lengkap" },
      { data: "cluster", title: "Cluster" },
      { data: "blok", title: "Blok" },
      { data: "no_rumah", title: "No. Rumah" },
      { data: "no_hp", title: "No. HP" },
      { data: "rt", title: "RT" },
      { data: "rw", title: "RW" },
    ],
    // 🔀 Default sort: blok ASC, no_rumah ASC
    order: [
      [3, "asc"], // blok
      [4, "asc"], // no_rumah
    ],
    language: {
      emptyTable: "Tidak ada data tersedia",
      loadingRecords: "Memuat...",
    },
  })

  // 🔀 Custom sorting logic
  table.on("order.dt", function () {
    const order = table.order()

    // Kalau disort kolom blok (index 3)
    if (order.length === 1 && order[0][0] === 3) {
      table
        .order([
          [3, order[0][1]], // blok ASC/DESC
          [4, "asc"], // no_rumah ASC
        ])
        .draw()
    }

    // Kalau disort kolom cluster (index 2)
    if (order.length === 1 && order[0][0] === 2) {
      table
        .order([
          [2, order[0][1]], // cluster ASC/DESC
          [3, "asc"], // blok ASC
          [4, "asc"], // no_rumah ASC
        ])
        .draw()
    }
  })

  // Klik row → load kendaraan
  $("#wargaTable tbody").on("click", "tr", async function () {
    const data = table.row(this).data()
    if (!data) return

    selectedWarga.value = data
    kendaraanLoading.value = true
    kendaraan.value = []

    const ProfileData = {
      email: data.email,
      token: token,
      user_login: userLogin,
    }

    try {
      const res = await axios.post(
        "https://metatekapps.metateknologi.com/api-vms-data-kendaraan.php",
        qs.stringify(ProfileData),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      kendaraan.value = res.data.data || []
    } catch (err) {
      console.error("Error ambil kendaraan:", err)
      kendaraan.value = []
    } finally {
      kendaraanLoading.value = false
      kendaraanModalInstance.show()
    }
  })
})
</script>

<style scoped>
table.dataTable th,
table.dataTable td {
  padding: 4px 8px !important;
  font-size: 14px;
}
.dataTables_wrapper {
  overflow-x: auto;
}
</style>
